export const GameInformationFormId = "game-information";

export enum GameInformationSubFormsId {
  ConceptDetails = "details",
  GameExpectations = "gameExpectations",
  PricingAndAvailability = "pricingAndAvailability",
  TechnicalCapabilities = "technicalCapabilities",
  Configurations = "configurations",
  XboxNetwork = "xboxNetwork",
  Ugc = "ugc",
  SupplementaryData = "supplementaryData",
}

export const GameInformationSubFormsIdsOrder = [
  GameInformationSubFormsId.ConceptDetails,
  GameInformationSubFormsId.GameExpectations,
  GameInformationSubFormsId.PricingAndAvailability,
  GameInformationSubFormsId.TechnicalCapabilities,
  GameInformationSubFormsId.Configurations,
  GameInformationSubFormsId.XboxNetwork,
  GameInformationSubFormsId.Ugc,
  GameInformationSubFormsId.SupplementaryData,
];

export const GameInformationSubFormsLocalizedStringIds: { [subForm: string]: string } = {
  ["formTitle"]: "gameInformationTitle",
  ["formSubtitle"]: "gameInformationSubtitleDescription",
  [GameInformationSubFormsId.ConceptDetails]: "gameInformationConceptDetailsTitle",
  [GameInformationSubFormsId.GameExpectations]: "gameInformationGameExpectationsTitle",
  [GameInformationSubFormsId.PricingAndAvailability]: "gameInformationPricingAndAvailabilityTitle",
  [GameInformationSubFormsId.TechnicalCapabilities]: "gameInformationTechnicalCapabilitiesTitle",
  [GameInformationSubFormsId.Configurations]: "gameInformationConfigurationsTitle",
  [GameInformationSubFormsId.XboxNetwork]: "gameInformationXboxNetworkTitle",
  [GameInformationSubFormsId.Ugc]: "gameInformationUgcTitle",
  [GameInformationSubFormsId.SupplementaryData]: "gameInformationSupplementaryDataTitle",
};
